import React, { useMemo } from "react";
import { useParams } from "react-router-dom";

export default function ProcedureViewer() {
    const { slug } = useParams();

    const src = useMemo(() => `/api/procedure/${slug}.php`, [slug]);

    return (
        <div className="w-full h-[calc(100vh-64px)]">
            <iframe
                src={src}
                title={`Procedura ${slug}`}
                className="w-full h-full rounded-xl bg-white"
            />
        </div>
    );
}
